import {Howl } from 'howler';
//import { ALPHA_MODES } from '../www/libs/pixi';
//https://github.com/goldfire/howler.js#documentation
export default class Audio {
    constructor() {
        this.sounds = {}
        this.isMuted = false;
    }
    load(id, src) {
         const sound = new Howl({
             html5: false,
             src: [src]
         });
        //const sound = new window.Audio(src);
         ////remove old sound and unload and destroy
         if(this.sounds[id] && this.sounds[id].unload) this.sounds[id].unload();
         this.sounds[id] = sound;
    }
    play(id) {
        if(this.isMuted ) return;

        let sound = this.sounds[id];
        if(!sound) return;
        sound.play();

        // const sound = PIXI.sound.find(id);
        // //multi play a not preloaded resource cause crash - https://github.com/pixijs/sound/issues/71
        // if (sound && sound.isLoaded) {
        //     PIXI.sound.play(id);
        // }
    }
    muteSet(isMuted) {
        this.isMuted = isMuted;

        // if (isMuted) Howler.volume(0);
        // else Howler.volume(1);

        // if (isMuted) PIXI.sound.volumeAll = 0;
        // else PIXI.sound.volumeAll = 1;
    }
}